module.exports = __webpack_public_path__ + "img/logo_white.2df61907.svg";